import {ReactElement, useContext, useEffect, useState} from "react";
import {AuthContext} from "../../../../contexts/AuthContext";
import {
    PayrollDefaultLevel,
    useListAllPayrollDefaultsLazyQuery,
} from "../../../../__generated__/generated_types";
import DefaultsForm, {LoadedPayrollDefaults, mapPayrollDefaults} from "./DefaultsForm";

interface PayrollDefaultsFormLoaderProps {
    positionId: string;
    defaultLevel: PayrollDefaultLevel;
    jurisdictionId?: string;
    propertyId?: string;
}

export default function DefaultsFormWithInitialData(props: PayrollDefaultsFormLoaderProps): ReactElement {
    const {
        positionId,
        defaultLevel,
        jurisdictionId,
        propertyId,
    } = props;
    const {user} = useContext(AuthContext);
    const clientId = user?.clientId ?? "";
    const [loadedDefaults, setLoadedDefaults] = useState<LoadedPayrollDefaults | undefined>();
    const [fetchAllDefaults] = useListAllPayrollDefaultsLazyQuery({
        fetchPolicy: "no-cache",
        onCompleted: data => setLoadedDefaults(mapPayrollDefaults(data)),
    });

    function loadDefaults() {
        if(!clientId || !positionId) return;
        if(defaultLevel === PayrollDefaultLevel.Jurisdiction && !jurisdictionId) return;
        if(defaultLevel === PayrollDefaultLevel.Property && !propertyId) return;
        setLoadedDefaults(undefined);
        fetchAllDefaults({
            variables: {
                filter: {
                    defaultLevel,
                    positionId,
                    clientId,
                    jurisdictionId,
                    propertyId,
                },
            },
        });
    }

    useEffect(() => {
        loadDefaults();
    }, [clientId, defaultLevel, positionId, jurisdictionId, propertyId]);

    return (
        <DefaultsForm
            positionIds={[positionId]}
            defaultLevel={defaultLevel}
            jurisdictionId={jurisdictionId}
            propertyId={propertyId}
            loadedDefaults={loadedDefaults}
            onSaved={loadDefaults}
            showResetControls
        />
    );
}
